import styled from 'styled-components';

export const TopicContentGrid = styled.div`
  display: grid;
  grid-template-columns: 60% 34%;
  justify-content: space-between;
  padding: 0 24px;
  transform: translateY(-40px);

  @media (max-width: 720px) {
    grid-template-columns: 100%;
    padding: 0;

    .mWebPadding {
      padding: 0 10px;
    }
  }
`;
